import { createTheme } from '@mui/material';
import mediaResolutions from '../constants/resolutions';

const theme = createTheme({
  palette: {
    text: {
      primary: '#000',
      secondary: '#fff',
    },
    primary: {
      main: '#424242',
    },
    secondary: {
      main: '#fff',
    },
  },
  typography: {
    fontFamily: 'Lato, sans-serif; Roboto',
    h1: {
      fontFamily: 'Cormorant, serif',
      [`@media (min-width:${mediaResolutions.sm})`]: {
        fontSize: '14rem',
      },
    },
    h2: {
      fontFamily: 'Cormorant, serif',
      [`@media (min-width:${mediaResolutions.sm})`]: {
        fontSize: '6rem',
      },
    },
    h3: {
      fontFamily: 'Cormorant, serif',
    },
    h4: {
      fontFamily: 'Cormorant, serif',
    },
    h5: {
      fontFamily: 'Cormorant, serif',
    },
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          opacity: '1 !important',
        },
      },
    },
  },
});

export default theme;
